import React, { useState } from 'react'
import ReportTable from '../../components/reports/table'
import { ReportControls, DisplayToggle, DateFormatToggle, ReportPeriodRange } from './report-controls'
import { ILeaveHistoryReportProps } from './types'
import { leaveRequestReportColumns } from '@vacationtracker/shared/types/export'

const LeaveHistoryReport: React.FC<ILeaveHistoryReportProps> = ({
  companyData,
  defaultDates,
  data,
  total,
  page,
  loading,
  dateFormat,
  display,
  defaultFilters,
  onFiltersChange,
  onPeriodChange,
  onDisplayChange,
  onDateFormatChange,
  loadNext,
  loadPrevious,
  download,
}) => {
  const [hideEmptyColumns, setHideEmptyColumns] = useState<boolean>(() => {
    const stored = localStorage.getItem('leave-history-report_hideEmptyColumns')
    if (stored !== null) return stored === 'true'
    localStorage.setItem('leave-history-report_hideEmptyColumns', 'true')
    return true
  })

  const handleHideEmptyColumnsChange = (value: boolean) => {
    setHideEmptyColumns(value)
    localStorage.setItem('leave-history-report_hideEmptyColumns', String(value))
  }

  return (
    <div>
      <ReportControls
        show={
          <>
            <ReportPeriodRange defaultDates={defaultDates} format={dateFormat} onChange={onPeriodChange} />
            <DisplayToggle value={display} onChange={onDisplayChange} />
            <DateFormatToggle value={dateFormat} onChange={onDateFormatChange} />
          </>
        }
        companyData={companyData}
        defaultFilters={defaultFilters}
        onFiltersChange={onFiltersChange}
        includeRequestFilters
      />
      <ReportTable
        columnNames={leaveRequestReportColumns}
        data={data}
        total={total}
        loadNext={loadNext}
        loadPrevious={loadPrevious}
        download={download}
        loading={loading}
        dateFormat={dateFormat}
        display={display}
        page={page}
        reportType="leave-history-report"
        editableColumns={true}
        hideEmptyColumns={hideEmptyColumns}
        onHideEmptyColumnsChange={handleHideEmptyColumnsChange}
      />
    </div>
  )
}

export default LeaveHistoryReport
